function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useApolloClient, useQuery } from "@apollo/client";
import { CommonActions as NavigationActions } from "@react-navigation/native";
import * as Sentry from "@sentry/react-native";
// import type { Dsn } from '@sentry/types';
import Constants from "expo-constants";
import * as Device from "expo-device";
import * as Notifications from "expo-notifications";
import { allowScreenCaptureAsync, preventScreenCaptureAsync } from "expo-screen-capture";
import * as Updates from "expo-updates";
import invert from "lodash/invert";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Clipboard, PanResponder, Platform } from "react-native";
import { captureScreen } from "react-native-view-shot";
import { z } from "zod";
import { graphql } from "@oui/lib/src/graphql/tada";
import { clearFrescoMemoryCache } from "@oui/native-utils";
import AppContext, { useAppContext } from "./AppContext";
import { Button } from "./Button";
import { Checkbox } from "./Checkbox";
import { Modal } from "./Modal";
import { PickerInput } from "./PickerInput";
import { Text } from "./Text";
import { NumberInput, TextInput } from "./TextInput";
import { View } from "./View";
import { WorksheetListItem } from "./WorksheetListItem";
import { APP_SLUG, environment, IS_PRODUCTION, isHermes, manifest } from "../constants";
import { PickerFormInput, useZodForm } from "../form";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { useIsLoggedIn } from "../hooks/useIsLoggedIn";
import { useLogout } from "../hooks/useLogout";
import { usePersistedState } from "../hooks/usePersistedState";
import { checkForUpdateAsync, fetchUpdateAsync, reloadAsync } from "../lib/checkForUpdateAsync";
import { getInstallationIDAsync } from "../lib/getInstallationIDAsync";
import { LOCALES } from "../lib/i18n";
import { mockConversationCompleteV2 } from "../lib/mockUserState";
import { getConfigString } from "../lib/remoteConfig";
import { setDeviceInfo } from "../lib/setDeviceInfo";
// function attachmentUrlFromDsn(dsn: Dsn, eventId: string) {
//   const { host, path, projectId, port, protocol, user } = dsn;
//   return `${protocol}://${host}${port !== '' ? `:${port}` : ''}${
//     path !== '' ? `/${path}` : ''
//   }/api/${projectId}/events/${eventId}/attachments/?sentry_key=${user}&sentry_version=7&sentry_client=custom-javascript`;
// }
var DevMenuQuery = graphql("\n  query DevMenu {\n    user {\n      ID\n      role {\n        ID\n        sessions {\n          session {\n            sessionID\n            contentType\n            name\n          }\n        }\n      }\n    }\n  }\n");
var IS_SIMPLE_DEV_MENU = APP_SLUG === 'oui-aviva-staff' && IS_PRODUCTION;
function ReportErrorSubscreen(props) {
    var _useState = _sliced_to_array(useState(''), 2), error = _useState[0], setError = _useState[1];
    var _useState1 = _sliced_to_array(useState(!IS_SIMPLE_DEV_MENU), 2), includeScreenshot = _useState1[0], setIncludeScreenshot = _useState1[1];
    function uploadScreenshot(id) {
        return _uploadScreenshot.apply(this, arguments);
    }
    function _uploadScreenshot() {
        _uploadScreenshot = _async_to_generator(function(id) {
            var uri, content;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            captureScreen({
                                format: 'png'
                            })
                        ];
                    case 1:
                        uri = _state.sent();
                        return [
                            4,
                            fetch("file://".concat(uri))
                        ];
                    case 2:
                        return [
                            4,
                            _state.sent().blob()
                        ];
                    case 3:
                        content = _state.sent();
                        fetch("https://storage.googleapis.com/upload/storage/v1/b/bug-reports.oui.dev/o?uploadType=media&name=".concat(id, ".png"), {
                            method: 'POST',
                            body: content
                        }).catch(Sentry.captureException);
                        return [
                            2
                        ];
                }
            });
        // const formData = new FormData();
        // formData.append('screenshot', content, 'screenshot.png');
        // const dsn = Sentry.getCurrentHub().getClient()?.getDsn();
        // console.log(formData, dsn, dsn ? attachmentUrlFromDsn(dsn, id) : null);
        // if (!dsn) return;
        // fetch(attachmentUrlFromDsn(dsn, id), {
        //   method: 'POST',
        //   body: formData,
        // });
        });
        return _uploadScreenshot.apply(this, arguments);
    }
    return /*#__PURE__*/ _jsxs(View, {
        spacing: 24,
        style: {
            height: 400
        },
        children: [
            /*#__PURE__*/ _jsx(TextInput, {
                label: "Describe your bug",
                multiline: true,
                value: error,
                onChangeValue: setError,
                placeholder: "Example: When I tried clicking on the 'Save' button, the screen turned blank."
            }),
            IS_SIMPLE_DEV_MENU ? null : /*#__PURE__*/ _jsx(Checkbox, {
                onChangeValue: setIncludeScreenshot,
                value: includeScreenshot,
                horizontal: true,
                label: "Include screenshot?"
            }),
            /*#__PURE__*/ _jsx(Button, {
                text: "Submit report",
                onPress: function() {
                    Sentry.withScope(function(scope) {
                        scope.setExtras({
                            error: error
                        });
                        var id = Sentry.captureException("DevMenu error report - ".concat(error));
                        Clipboard.setString(id);
                        setError('');
                        props.onRequestClose();
                        if (Platform.OS !== 'web' && includeScreenshot) {
                            setTimeout(function() {
                                // id is undefined if sentry is disabled
                                void uploadScreenshot(id || Date.now().toString());
                            }, 500);
                        }
                    });
                }
            })
        ]
    });
}
function UserSubscreen(props) {
    var _currentUser_user, _learnData_user_role_sessions, _learnData_user_role, _learnData_user, _sessionItems_, _currentUser_user_role, _currentUser_user1, _currentUser_user2;
    var _useCurrentUser = useCurrentUser(), currentUser = _useCurrentUser.data, isLoggedIn = _useCurrentUser.isLoggedIn;
    var logout = useLogout();
    var userID = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser_user = currentUser.user) === null || _currentUser_user === void 0 ? void 0 : _currentUser_user.ID;
    var apollo = useApolloClient();
    var _useQuery = useQuery(DevMenuQuery, {
        skip: !userID
    }), learnData = _useQuery.data;
    var _learnData_user_role_sessions_map;
    var sessionItems = (_learnData_user_role_sessions_map = learnData === null || learnData === void 0 ? void 0 : (_learnData_user = learnData.user) === null || _learnData_user === void 0 ? void 0 : (_learnData_user_role = _learnData_user.role) === null || _learnData_user_role === void 0 ? void 0 : (_learnData_user_role_sessions = _learnData_user_role.sessions) === null || _learnData_user_role_sessions === void 0 ? void 0 : _learnData_user_role_sessions.map(function(t) {
        return {
            label: t.session.name,
            value: t.session.contentType
        };
    })) !== null && _learnData_user_role_sessions_map !== void 0 ? _learnData_user_role_sessions_map : [];
    var form = useZodForm(z.object({
        completeThrough: z.string()
    }), {
        defaultValues: {
            completeThrough: (_sessionItems_ = sessionItems[0]) === null || _sessionItems_ === void 0 ? void 0 : _sessionItems_.value
        }
    });
    var completeThrough = form.watch('completeThrough');
    return /*#__PURE__*/ _jsxs(View, {
        spacing: 8,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                text: "Logged in?: ".concat(isLoggedIn ? 'yes' : 'no')
            }),
            isLoggedIn ? /*#__PURE__*/ _jsxs(View, {
                spacing: 8,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        text: "User ID: ".concat(userID)
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        text: "Role ID: ".concat(currentUser === null || currentUser === void 0 ? void 0 : (_currentUser_user1 = currentUser.user) === null || _currentUser_user1 === void 0 ? void 0 : (_currentUser_user_role = _currentUser_user1.role) === null || _currentUser_user_role === void 0 ? void 0 : _currentUser_user_role.ID)
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        text: "Email: ".concat(currentUser === null || currentUser === void 0 ? void 0 : (_currentUser_user2 = currentUser.user) === null || _currentUser_user2 === void 0 ? void 0 : _currentUser_user2.email)
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        spacing: 8,
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        weight: "bold",
                                        text: "Complete sessions through:"
                                    }),
                                    /*#__PURE__*/ _jsxs(View, {
                                        row: true,
                                        spacing: 16,
                                        children: [
                                            /*#__PURE__*/ _jsx(View, {
                                                flex: 1,
                                                children: /*#__PURE__*/ _jsx(PickerFormInput, {
                                                    control: form.control,
                                                    name: "completeThrough",
                                                    items: sessionItems
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                text: "Submit",
                                                onPress: function() {
                                                    var promises = [];
                                                    for(var index = 0; index < sessionItems.length; index = index + 1){
                                                        var session = sessionItems[index];
                                                        promises.push(mockConversationCompleteV2(apollo, session.value));
                                                        if (session.value === completeThrough) break;
                                                    }
                                                    return Promise.all(promises);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                text: "Logout",
                                onPress: logout,
                                alignSelf: "flex-start"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ _jsx(View, {
                spacing: 8,
                children: /*#__PURE__*/ _jsx(Button, {
                    text: "Create test user",
                    onPress: function() {
                        props.onNavigate(NavigationActions.navigate({
                            name: 'CreateTestUser'
                        }));
                    },
                    alignSelf: "flex-start"
                })
            })
        ]
    });
}
var Subscreen = /*#__PURE__*/ function(Subscreen) {
    Subscreen["None"] = "";
    Subscreen["About"] = "about";
    Subscreen["ReportError"] = "reportError";
    Subscreen["User"] = "user";
    Subscreen["Flags"] = "flags";
    Subscreen["Other"] = "other";
    return Subscreen;
}(Subscreen || {});
/**
 * Hidden UI intended to be used by developers to provide easy access to
 * debugging information, actions, and error reporting.
 *
 * The menu opens if the user presses and holds with three fingers.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-81}
 */ export function DevMenu(param) {
    var onNavigate = param.onNavigate, children = param.children;
    var _useState = _sliced_to_array(useState(''), 2), sentryId = _useState[0], setSentryId = _useState[1];
    var _useState1 = _sliced_to_array(useState(''), 2), installationId = _useState1[0], setInstallationId = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), showModal = _useState2[0], setShowModal = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), subscreen = _useState3[0], setSubscreen = _useState3[1];
    var _useState4 = _sliced_to_array(useState(''), 2), locale = _useState4[0], setLocale = _useState4[1];
    var _useState5 = _sliced_to_array(useState({}), 2), flagOverrides = _useState5[0], setFlagOverrides = _useState5[1];
    var openTimeoutRef = useRef(0);
    var isLoggedIn = useIsLoggedIn();
    var appContext = useAppContext();
    var _usePersistedState = _sliced_to_array(usePersistedState('disableLocalAuthentication', false), 2), disableLocalAuthentication = _usePersistedState[0], setDisableLocalAuthentication = _usePersistedState[1];
    var apollo = useApolloClient();
    var _useState6 = _sliced_to_array(useState(false), 2), isUpdateAvailable = _useState6[0], setIsUpdateAvailable = _useState6[1];
    useEffect(function() {
        if (Platform.OS !== 'web') {
            if (showModal) {
                void allowScreenCaptureAsync();
                return function() {
                    void preventScreenCaptureAsync();
                };
            }
        }
        return;
    }, [
        showModal
    ]);
    function applyUpdate() {
        return _applyUpdate.apply(this, arguments);
    }
    function _applyUpdate() {
        _applyUpdate = _async_to_generator(function() {
            var e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetchUpdateAsync()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            reloadAsync()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        Sentry.captureException(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _applyUpdate.apply(this, arguments);
    }
    var openDevMenu = useCallback(function() {
        var id = Sentry.captureMessage('DevMenu opened');
        setSentryId(id);
        checkForUpdateAsync().then(function(param) {
            var isAvailable = param.isAvailable;
            if (isAvailable) {
                setIsUpdateAvailable(true);
            }
        }).catch(Sentry.captureException);
        setShowModal(true);
    }, []);
    useEffect(function() {
        void getInstallationIDAsync().then(setInstallationId);
    }, []);
    var _useState7 = _sliced_to_array(useState(function() {
        return PanResponder.create({
            onMoveShouldSetPanResponder: function(_evt, gestureState) {
                return gestureState.numberActiveTouches === (Device.isDevice ? 3 : 2);
            },
            onPanResponderGrant: function(_evt, _gestureState) {
                openTimeoutRef.current = setTimeout(function() {
                    openDevMenu();
                }, IS_PRODUCTION ? 1500 : 500);
            },
            onPanResponderRelease: function() {
                clearTimeout(openTimeoutRef.current);
            },
            onPanResponderTerminate: function() {
                clearTimeout(openTimeoutRef.current);
            }
        });
    }), 1), panResponder = _useState7[0];
    useEffect(function() {
        if (Platform.OS === 'web') {
            // eslint-disable-next-line
            global.showDevMenu = openDevMenu;
            // eslint-disable-next-line
            global.showReportErrorMenu = function() {
                openDevMenu();
                setSubscreen("reportError");
            };
        }
    }, [
        openDevMenu
    ]);
    var overriddenAppContext = useMemo(function() {
        var flags = _object_spread({}, appContext.flags, flagOverrides);
        return _object_spread_props(_object_spread({}, appContext), {
            flags: flags,
            locale: locale || appContext.locale
        });
    }, [
        appContext,
        flagOverrides,
        locale
    ]);
    return /*#__PURE__*/ _jsx(View, _object_spread_props(_object_spread({
        style: {
            flex: 1
        }
    }, panResponder.panHandlers), {
        children: /*#__PURE__*/ _jsxs(AppContext.Provider, {
            value: overriddenAppContext,
            children: [
                children,
                /*#__PURE__*/ _jsx(Modal, {
                    visible: showModal,
                    onRequestClose: function() {
                        setShowModal(false);
                        setSubscreen("");
                    },
                    _onBack: subscreen && !IS_SIMPLE_DEV_MENU ? function() {
                        setSubscreen("");
                    } : undefined,
                    heading: subscreen ? invert(Subscreen)[subscreen] : 'Debug menu',
                    maxHeight: 300,
                    children: /*#__PURE__*/ _jsx(View, {
                        children: subscreen === "about" ? /*#__PURE__*/ _jsxs(View, {
                            spacing: 8,
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    text: "Environment: ".concat(environment)
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    text: "Latest Version: ".concat(manifest.version)
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    text: "Build Version: ".concat(Constants.nativeBuildVersion)
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    text: "Sentry ID: ".concat(sentryId)
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    text: "Device ID: ".concat(installationId)
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    text: "Published at: ".concat('createdAt' in Updates.manifest ? Updates.manifest.createdAt : 'Build time')
                                }),
                                Updates.channel ? /*#__PURE__*/ _jsx(Text, {
                                    text: "Release channel: ".concat(Updates.channel)
                                }) : null,
                                /*#__PURE__*/ _jsx(Text, {
                                    text: "API: ".concat(getConfigString('apiUrl'))
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    text: "Hermes: ".concat(isHermes())
                                })
                            ]
                        }) : subscreen === "reportError" ? /*#__PURE__*/ _jsx(ReportErrorSubscreen, {
                            onRequestClose: function() {
                                setShowModal(false);
                                setSubscreen("");
                            }
                        }) : subscreen === "flags" ? /*#__PURE__*/ _jsxs(View, {
                            spacing: 8,
                            children: [
                                /*#__PURE__*/ _jsx(Checkbox, {
                                    label: "Disable local authentication",
                                    value: disableLocalAuthentication,
                                    onChangeValue: setDisableLocalAuthentication,
                                    horizontal: true
                                }),
                                /*#__PURE__*/ _jsx(PickerInput, {
                                    label: "Locale",
                                    items: LOCALES.map(function(l) {
                                        return {
                                            label: l,
                                            value: l
                                        };
                                    }),
                                    value: locale,
                                    onChangeValue: setLocale
                                }),
                                Object.keys(appContext.flags).map(function(key) {
                                    var flagType = _type_of(appContext.flags[key]);
                                    var _flagOverrides_key;
                                    var value = (_flagOverrides_key = flagOverrides[key]) !== null && _flagOverrides_key !== void 0 ? _flagOverrides_key : appContext.flags[key];
                                    var onChangeValue = function(newValue) {
                                        setFlagOverrides(_object_spread_props(_object_spread({}, flagOverrides), _define_property({}, key, newValue)));
                                    };
                                    return /*#__PURE__*/ _jsx(View, {
                                        children: flagType === 'boolean' ? /*#__PURE__*/ _jsx(Checkbox, {
                                            value: value,
                                            onChangeValue: onChangeValue,
                                            label: key,
                                            horizontal: true
                                        }) : flagType === 'number' ? /*#__PURE__*/ _jsx(NumberInput, {
                                            value: value,
                                            onChangeValue: onChangeValue,
                                            label: key
                                        }) : null
                                    }, key);
                                })
                            ]
                        }) : subscreen === "user" ? /*#__PURE__*/ _jsx(UserSubscreen, {
                            onNavigate: onNavigate
                        }) : subscreen === "other" ? /*#__PURE__*/ _jsxs(View, {
                            spacing: 24,
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    text: "Hope Kit",
                                    onPress: function() {
                                        onNavigate(NavigationActions.navigate({
                                            name: 'HopeKit'
                                        }));
                                        setShowModal(false);
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    text: "Activity Diary",
                                    onPress: function() {
                                        onNavigate(NavigationActions.navigate({
                                            name: 'ActivityDiary'
                                        }));
                                        setShowModal(false);
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    text: "Thought Diary",
                                    onPress: function() {
                                        onNavigate(NavigationActions.navigate({
                                            name: 'ThoughtDiary'
                                        }));
                                        setShowModal(false);
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    text: "Sleep Diary",
                                    onPress: function() {
                                        onNavigate(NavigationActions.navigate({
                                            name: 'SleepDiary'
                                        }));
                                        setShowModal(false);
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    text: "Clear Fresco Memory Cache",
                                    onPress: function() {
                                        clearFrescoMemoryCache();
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    text: "Open gallery",
                                    onPress: function() {
                                        onNavigate(NavigationActions.navigate({
                                            name: 'MediaPicker',
                                            params: {
                                                returnRoute: 'home'
                                            }
                                        }));
                                        setShowModal(false);
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    text: "Copy push token",
                                    onPress: /*#__PURE__*/ _async_to_generator(function() {
                                        var _Constants_expoConfig_extra, _Constants_expoConfig, _ref, token;
                                        return _ts_generator(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        Notifications.getPermissionsAsync()
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        4,
                                                        Notifications.getExpoPushTokenAsync({
                                                            projectId: (_Constants_expoConfig = Constants.expoConfig) === null || _Constants_expoConfig === void 0 ? void 0 : (_Constants_expoConfig_extra = _Constants_expoConfig.extra) === null || _Constants_expoConfig_extra === void 0 ? void 0 : _Constants_expoConfig_extra.eas.projectId
                                                        })
                                                    ];
                                                case 2:
                                                    _ref = _state.sent(), token = _ref.data;
                                                    Clipboard.setString(token);
                                                    if (isLoggedIn) {
                                                        return [
                                                            2,
                                                            setDeviceInfo(apollo)
                                                        ];
                                                    }
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    text: "JS Error",
                                    onPress: function() {
                                        try {
                                            // eslint-disable-next-line
                                            global.qwer();
                                        } catch (e) {
                                            Sentry.captureException(e);
                                        }
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    text: "Crash",
                                    onPress: function() {
                                        Sentry.nativeCrash();
                                    }
                                })
                            ]
                        }) : /*#__PURE__*/ _jsxs(View, {
                            style: {
                                marginTop: -20
                            },
                            children: [
                                isUpdateAvailable ? /*#__PURE__*/ _jsxs(View, {
                                    row: true,
                                    style: {
                                        paddingVertical: 10,
                                        justifyContent: 'space-between'
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            text: "Update available: "
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            text: "Apply",
                                            alignSelf: "center",
                                            onPress: applyUpdate
                                        })
                                    ]
                                }) : null,
                                Object.entries(Subscreen).map(function(param) {
                                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                                    return value ? /*#__PURE__*/ _jsx(View, {
                                        style: {
                                            borderBottomWidth: 1,
                                            borderColor: '#eee',
                                            marginHorizontal: -20,
                                            paddingHorizontal: 20
                                        },
                                        children: /*#__PURE__*/ _jsx(WorksheetListItem, {
                                            text: key,
                                            onPress: function() {
                                                return setSubscreen(value);
                                            }
                                        })
                                    }, key) : null;
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }));
}
